import React from "react";
import T from '../../../components/common/T';
import { useConsumption } from "../../../context/ConsumptionContext";

export default function StockUsageView() {
  const { issuances } = useConsumption();

  return (
    <div className="bg-white dark:bg-[#161b22] rounded-lg shadow-sm border border-gray-200 dark:border-[#30363d] overflow-hidden transition-colors">
        {issuances.length === 0 ? (
            <div className="p-10 text-center text-gray-500 dark:text-slate-400">
                <p><T>No material has been issued to sites yet.</T></p>
            </div>
        ) : (
            <table className="w-full text-sm text-left">
                <thead className="bg-gray-50 dark:bg-[#21262d] text-gray-500 dark:text-slate-400 uppercase font-bold text-xs">
                    <tr>
                        <th className="px-6 py-3"><T>Date</T></th>
                        <th className="px-6 py-3"><T>Slip ID</T></th>
                        <th className="px-6 py-3"><T>Project</T></th>
                        <th className="px-6 py-3"><T>Material</T></th>
                        <th className="px-6 py-3"><T>Source</T></th>
                        <th className="px-6 py-3 text-right"><T>Qty</T></th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 dark:divide-[#30363d]">
                    {issuances.map((issuance) => (
                        <tr key={issuance.id} className="hover:bg-gray-50 dark:hover:bg-[#1E293B] transition-colors">
                            <td className="px-6 py-4 text-gray-700 dark:text-slate-300">{new Date(issuance.date).toLocaleDateString()}</td>
                            <td className="px-6 py-4 font-mono text-xs text-blue-600 dark:text-blue-400">{issuance.id}</td>
                            <td className="px-6 py-4 font-medium text-gray-900 dark:text-white">
                                {issuance.projectName}
                                {issuance.taskName && <span className="block text-xs text-gray-500 dark:text-slate-400">Task: {issuance.taskName}</span>}
                            </td>
                            <td className="px-6 py-4 text-gray-900 dark:text-slate-200">{issuance.materialName}</td>
                            <td className="px-6 py-4 text-xs text-gray-500 dark:text-slate-400">
                                Bin: {issuance.bin}
                            </td>
                            <td className="px-6 py-4 text-right font-bold text-red-600 dark:text-red-400">-{issuance.quantity}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        )}
    </div>
  );
}
